import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import {
  AlertError,
  FormDashboardLabel as Label,
  FormRow,
  SaveButton,
  VisibilityRadios as Radios,
} from '../../../components'
import apiService from '../../../features/api/service'
import { visibilityField } from '../../../features/visibility/config'
import { errorHandler, sentenceTitleCase, visibilityWordBlacklist } from '../../../utils'

const ContentGeneral = ({fieldKey}) => {
  const [form, setForm] = useState({})
  const [requesting, setRequesting] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const { visibilityDefault = {} } = useSelector(state => state.organization.data)
  const { pkVisibilityDefaultId } = visibilityDefault

  const handleRadioChanges = (e) => {
    setForm({
      ...form,
      [e.target.name]: parseInt(e.target.value)
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if(pkVisibilityDefaultId){
      setRequesting(true)
      setErrorMessage(null)

      const requestBody = {
        [fieldKey]: form
      }

      apiService.update('organization_visibility', pkVisibilityDefaultId, requestBody)
        .then(() => {
          toast.success('Successfully updated!')
        })
        .catch(err => {
          const msg = errorHandler(err)
          setErrorMessage(msg)
        })
        .finally(() => setRequesting(false))
    } else {
      setErrorMessage('Error 400: pkVisibilityDefaultId is undefined.')
    }
  }

  useEffect(() => {
    if(visibilityDefault[fieldKey]){
      setForm(visibilityDefault[fieldKey])
    } else if (visibilityField[fieldKey]) {
      setForm(visibilityField[fieldKey])
    }
  }, [visibilityDefault, fieldKey])

  return (
    <form className="w-full pb-10 lg:pb-0" onSubmit={handleSubmit}>
      {
        Object.keys(form).map((key) => (
          <FormRow key={key}>
            <div className="mb-5 lg:mb-10">
              <Label>{sentenceTitleCase(key.split('vsb')[1], visibilityWordBlacklist)}</Label>
              <div className="pt-3">
                <Radios
                  name={key}
                  value={form[key]}
                  onChange={e => {e.persist(); handleRadioChanges(e)}}
                />
              </div>
            </div>
          </FormRow>
        ))
      }

      {
        errorMessage !== null &&
        <div className="mb-8">
          <AlertError message={errorMessage} onClose={() => setErrorMessage(null)}/>
        </div>
      }

      <SaveButton
        disabled={requesting}
        isLoading={requesting}
      />
    </form>
  )
}

export { ContentGeneral }
